import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlog = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			opacity: .15,
			x: 2,
			y: 4,
			width: 20,
			height: 15,
			rx: 3,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 11C9.10457 11 10 11.8954 10 13V15C10 16.1046 9.10457 17 8 17H6C4.89543 17 4 16.1046 4 15V13C4 11.8954 4.89543 11 6 11H8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 6C19.3284 6 20 6.67157 20 7.5C20 8.32843 19.3284 9 18.5 9H5.5C4.67157 9 4 8.32843 4 7.5C4 6.67157 4.67157 6 5.5 6H18.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .6,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13C12.4477 13 12 12.5523 12 12C12 11.4477 12.4477 11 13 11H19Z",
				fill: "currentColor"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M19 15C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H13C12.4477 17 12 16.5523 12 16C12 15.4477 12.4477 15 13 15H19Z",
				fill: "currentColor"
			})]
		})
	]
});
const ForwardRef = forwardRef(SvgBlog);
export { ForwardRef as ReactComponent };
